import React, { useState, forwardRef, useImperativeHandle } from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import CreateIcon from '@mui/icons-material/Create';
import { Button, Accordion, AccordionSummary, AccordionDetails, Grid } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import clsx from 'clsx';

const AnalysisInputPanel = forwardRef((props, ref) => {
  const { inputTitle, slider, detailComponents, className, ...rest } = props;

  const [inputGroupExpanded, setInputGroupExpanded] = useState(false);
  const ToggleButtonSx = {
    minWidth: 48,
    minHeight: 33,
    padding: 0,
    color: '#fff'
  };

  // disabled due to mobile virtual keyboard
  // useEffect(() => {
  //   const onScroll = (event) => {
  //     closeInput();
  //   };
  //
  //   window.addEventListener('scroll', onScroll);
  //
  //   return () => {
  //     window.removeEventListener('scroll', onScroll);
  //   };
  // }, []);

  useImperativeHandle(ref, () => ({
    openInput: openInput,
    closeInput: closeInput
  }));

  const handleInputGroupChange = () => {
    setInputGroupExpanded(!inputGroupExpanded);
  };

  const closeInput = () => {
    setInputGroupExpanded(false);
  };

  const openInput = () => {
    setInputGroupExpanded(true);
  };

  const onClickAway = event => {
    let found = false;
    console.log(event.constructor.name);
    if (event.constructor.name !== 'TouchEvent' && event.constructor.name !== 'MouseEvent') {
      return;
    }

    const path = event.composedPath ? event.composedPath() : event.path;
    if (path) {
      found = path.find(element => {
        if (!element?.className) {
          return false;
        }

        if (!element.className.includes) {
          return false;
        }

        return (
          element.className.includes('sticky-clickaway-exception') || element.className.includes('ReactModalPortal')
        );
      });
    }

    if (!found) {
      closeInput();
    }
  };

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <Accordion
        className={clsx(['analysis-expansion', 'analysis-input-group'], className)}
        expanded={inputGroupExpanded}
        {...rest}
        slotProps={{
          transition: {
            className: 'analysis-input-group-detail-collapse'
          }
        }}
      >
        <AccordionSummary
          className="analysis-expansion-summary analysis-input-group-summary"
          sx={{
            minHeight: 'unset !important',
            // The slider's own bottom padding spaces the row; without one the
            // toggle button would sit on the bottom border.
            padding: `10px 15px ${slider ? 0 : '10px'} 15px !important`,
            '&.Mui-expanded': {
              minHeight: 'unset !important'
            },
            '& .MuiAccordionSummary-content': {
              margin: '0 !important',
              width: '100%'
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
              margin: '0 !important'
            }
          }}
        >
          <Grid container sx={{ flexDirection: 'column', rowGap: 0 }}>
            <Grid>
              {/* v9: title col uses flex-grow + minWidth:0 so it shrinks to fit
                  the row instead of forcing the toggle button below.
                  Old `width: calc(100% - 56px)` assumed v4's 56px default
                  Button width — v9's Button is 64px and was overflowing. */}
              <Grid
                container
                spacing={1}
                sx={{
                  alignItems: 'center',
                  flexWrap: 'nowrap'
                }}
              >
                <Grid sx={{ flexGrow: 1, minWidth: 0 }}>{inputTitle}</Grid>
                <Grid>
                  {inputGroupExpanded ? (
                    <Button
                      component="span"
                      variant="contained"
                      color="secondary"
                      className="analysis-input-group-toggle analysis-input-group-toggle-apply"
                      sx={{
                        ...ToggleButtonSx,
                        backgroundColor: '#3eeef8',
                        '&:hover': { backgroundColor: '#3eeef8' }
                      }}
                      onClick={handleInputGroupChange}
                    >
                      <RemoveIcon />
                    </Button>
                  ) : (
                    <Button
                      component="span"
                      variant="contained"
                      color="secondary"
                      className="analysis-input-group-toggle analysis-input-group-toggle-change"
                      sx={{
                        ...ToggleButtonSx,
                        backgroundColor: '#3966f8',
                        '&:hover': { backgroundColor: '#3966f8' }
                      }}
                      onClick={handleInputGroupChange}
                    >
                      <CreateIcon />
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            {slider && <Grid sx={{ display: 'block' }}>{slider}</Grid>}
          </Grid>
        </AccordionSummary>

        <AccordionDetails className="analysis-input-group-detail">{detailComponents}</AccordionDetails>
      </Accordion>
    </ClickAwayListener>
  );
});

export default AnalysisInputPanel;
